/**
 * Check-in (ticket redemption) types
 */

export enum CheckInOutcome {
  Ok = "OK",
  NoAccessToArea = "NO_ACCESS_TO_AREA",
  OutsideTimeslot = "OUTSIDE_TIMESLOT",
  EntryLimitReached = "ENTRY_LIMIT_REACHED",
  IntervalNotElapsed = "INTERVAL_NOT_ELAPSED",
  Expired = "EXPIRED",
  WrongVenue = "WRONG_VENUE",
  AlreadyRedeemed = "ALREADY_REDEEMED",
  NotEligibleNow = "NOT_ELIGIBLE_NOW",
}

/** Scan direction of the bound area. POS check-in only uses Entry. */
export enum CheckInMode {
  Entry = 1,
  Exit = 2,
  Dual = 3,
}

/** All fields are null when no area is bound to this POS config. */
export interface ICheckInConfig {
  areaId: number | null;
  areaCode: string | null;
  areaName: string | null;
  mode: CheckInMode | null;
  autoScanOnSale: boolean;
}

export interface IRedeemTokensPayload {
  groupId: number;
  posConfigId: number;
  tokenIds: string[];
  deviceId?: number;
  userId?: number;
}

export interface IRedeemByBarCodePayload {
  groupId: number;
  posConfigId: number;
  barCode: string;
  deviceId?: number;
  userId?: number;
}

export interface IRedeemResult {
  tokenId: string;
  outcome: CheckInOutcome;
  message: string;
  scannedAt: string | null;
}

/**
 * The order and token are null when the code resolves no ticket of an order
 * the group may act on.
 */
export interface IRedeemByBarCodeResult {
  outcome: CheckInOutcome;
  message: string;
  orderId: string | null;
  tokenId: string | null;
  scannedAt: string | null;
}

/** Tickets of one order that are in, against the tickets that can be. */
export interface IBookingCheckedIn {
  checkedIn: number;
  total: number;
}

/** How many tickets of one order are already in, from the ticket index. */
export interface IBookingScanCount {
  bookingId: number;
  /** Access tickets the order holds. */
  total: number;
  checkedIn: number;
}

/** Action stored on a scan log row by the engine. */
export enum ScanLogAction {
  Scan = 2,
  Unscan = 3,
}

export interface IScanLogUser {
  id: number;
  firstName: string | null;
  lastName: string | null;
}

export interface IScanLog {
  id: number;
  action: ScanLogAction;
  createdAt: string;
  scanningUser: IScanLogUser | null;
}

/** The scans of one ticket, inside a whole order answer. */
export interface IOrderTokenHistory extends ITicketScanHistory {
  tokenId: string;
}

export interface ITicketScanHistory {
  scanLogs: IScanLog[];
  maxEntrance: number | null;
  totalScans: number;
  validScans: number;
  unscans: number;
}
